/** Register PWA service worker (no-op in dev if unsupported). */
export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch(() => {
        // Silent — SW is a progressive enhancement.
      });
  });
}
